import { Component, OnInit } from '@angular/core';
import { PlantpredictService } from '../services/plantpredict.service';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-plantpredictor',
  templateUrl: './plantpredictor.component.html',
  styleUrls: ['./plantpredictor.component.css']
})
export class PlantpredictorComponent implements OnInit {
  soiltextures: string[] = ['Coarse', 'Medium', 'Fine'];
  droughttolerances: string[] = ['None', 'Low', 'Medium', 'High'];
  shadetolerances: string[] = ['Tolerant', 'Intermediate', 'Intolerant'];
  durations: string[] = ['Annual','Biennial', 'Perennial'];
  growthhabits: string[] = ['Forb/Herb','Graminoid','Shrub','Subshrub','Tree','Vine'];
  formvalid: Boolean;
  formmessage: string;
  predictedplants: any;
  predictiondata: any;
  collectdata: any;
  errMess: any;
  error: boolean;
  logStatus: any;
  perennial: "Perrenial";
  constructor( private plantService: PlantpredictService, private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.loadUserCredentials();
    this.logStatus  = this.authService.isLoggedIn();
  }

  predictinfo(data){
    if(this.logStatus){
      this.formvalid = data.valid;
      this.formmessage = null;
      if(this.formvalid){
       // console.log(data.value);
        this.collectdata = data.value;
        this.predictplant(data.value);
      }
      else{
        this.formmessage = "Invalid Form, Fill all fields";
      }
    }
    else{
      this.router.navigateByUrl("/login");
    }
  }

  predictplant(plantdata){
    //console.log(plantdata);
    plantdata = {...plantdata, duration: "perennial"};
    this.plantService.predictplant(plantdata).subscribe(res=>{
     // console.log(res.prediction);
      this.predictiondata = res;
      this.predictedplants = res.prediction;
    },error=>{
     // console.log(error);
      this.error = true;
      if(error.status == 400){
        this.errMess = "Form Data Invalid";
      }
      else{
        this.errMess = error.statusText;
      }
    })
  }

  filterplants(data){
    //console.log("update");
    //console.log(data.value);
    const obj1 = JSON.parse(JSON.stringify(this.collectdata));
    const obj2 = JSON.parse(JSON.stringify(data.value));
    this.collectdata = {...obj1,...obj2};
    //console.log(this.collectdata);
    this.predictplant(this.collectdata);
  }

  capitalize(s){
    let merged = "";
    let words = s.split(" ");
    words.forEach(word=>{
      merged = merged +" "+ word.charAt(0).toUpperCase()+word.slice(1);
    });
    return merged;
  }

  downloadresult(){
    var doc = new jsPDF();
    //doc.addImage('assets/', 'JPEG', data.settings.margin.left, 20, 50, 50);
    doc.setFontSize(30);
    doc.text("Prediction Result\n\n\n",70,30);
    doc.setFontSize(13);
    const features = "pH: "+ this.predictiondata.ph+"\nSoil Texture: "+this.capitalize(this.predictiondata.soil_texture)+
    "\nDrought Tolerance: "+this.capitalize(this.predictiondata.drought_tolerance)+"\nMinimun Temperature(C): "+this.predictiondata.min_temperature
    +"\nMinimum Precipitation(inches): "+this.predictiondata.min_precipitation+"\nMaximum Precipitation(inches): "+this.predictiondata.max_precipitation+
    "\nGrowth Habit: "+this.capitalize(this.predictiondata.growth_habit)+"\nShade Tolerance: "+this.capitalize(this.predictiondata.shade_tolerance)+
    "\nDuration: "+this.capitalize(this.predictiondata.duration);
    doc.text(features,18,50);
    var col = ["Symbol","Scientific Name", "Common Name"];
    var rows = [];
    //console.log(this.predictiondata.ph);
    //rows.push(this.predictiondata.ph, this.predictiondata.soil_texture);
/* The following array of object as response from the API req  */

var options = {
  margin: {
    top: 120
  },
  theme: 'grid'
};
var itemNew = this.predictedplants

itemNew.forEach(plant => {      
    var temp = [plant.symbol,this.capitalize(plant.scientific_name),this.capitalize(plant.common_name)];
    rows.push(temp);
});        
    (doc as any).autoTable(col, rows, options);
    
    doc.save('agrorecon_prediction.pdf');
  }
}
